import PhotographerCalendarApi from '../PhotographerCalendarApi';
import * as types from './ActionTypes';

function getCalendarSuccess(result: any) {
    return { type: types.GET_CALENDAR_SUCCESS, result };
}

export function getCalendar(from: any, to: any) {
    return (dispatch: (result: any) => void) =>
        PhotographerCalendarApi.getCalendar(from, to).then((result: any) => {
            dispatch(getCalendarSuccess(result));
        });
}

function updateCalendarSuccess(result: any) {
    return { type: types.UPDATE_CALENDAR_SUCCESS, result };
}

export function updateCalendar(data: any) {
    return (dispatch: (result: any) => void) =>
        PhotographerCalendarApi.updateCalendar(data.calendar).then((result: any) => {
            dispatch(updateCalendarSuccess(result));
        });
}

export function unbookEvent(id: number): any {
    return () => PhotographerCalendarApi.unbookEvent(id);
}
